import React from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const Career = () => {
    const location = useLocation();
    console.log("locationCareer", location?.pathname);
    return (
        <>
            <Helmet>
                <title>Careers at iLine Logistics | Join the Leading Logistics Company in India </title>
                <meta name="description" content="Looking for a career in AI logistics? Explore exciting job opportunities at iLine Logistics app. Join a dynamic team committed to innovation, efficiency, and growth in the logistics and delivery industry." />
                <link rel="canonical" href={`https://iline.ai${location.pathname}`} />
            </Helmet>
            <Header />
            <section className='ourServices'>
                <div className="container">
                    <div className="osLeft">
                        <h2>Careers</h2>
                    </div>
                    <div className="osRight">
                        <p style={{ marginBottom: '0px' }}><span style={{ fontWeight: '600', color: '#000' }}>Join Our Team at Iline.AI !</span></p>
                        <p style={{ marginTop: '5px', marginBottom: '0px' }}>Are you ready to take your career to new heights? At Iline Logistics, we empower individuals to reach their full potential—and we’re looking for talented individuals like you to help us drive success.</p>
                        <p style={{ margin: '0px' }}>If you’re ready to grow with us and be part of a dynamic, innovative team, send your application to the Iline head office today.</p>
                        <p style={{ marginTop: '5px' }}><span style={{ fontWeight: '600', color: '#000' }}>Your future starts here. Are you ready to reach yours?</span></p>

                    </div>
                </div>
            </section>

            {/* <section className="HowWeHelp">
                <div className="section-title">
                    <h2>How we help businesses <br /> across the world.
                    </h2>
                </div>
                <div className="container">
                    <div className="HowLine">
                        <div className="CenterLine">
                        </div>
                        <span className="CenterLineImg"><img src={require('../../assets/images/home/main_circle.svg').default} /></span>
                        <span className="Left"><img src={require('../../assets/images/home/small_circle.svg').default} /></span>
                        <span className="Right"><img src={require('../../assets/images/home/small_circle.svg').default} /></span>
                        <span className="Center"><img src={require('../../assets/images/home/small_circle.svg').default} /></span>
                    </div>
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="HwhBox">
                                <h2>Grow Customers</h2>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="HwhBox text-center">
                                <h2>Configured To You
                                </h2>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="HwhBox text-end">
                                <h2>Ultimate Data Protection
                                </h2>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            </div>
                        </div>
                    </div>
                    <figure><img src={require('../../assets/images/career/career-banner.jpg')} /></figure>
                </div>
            </section> */}

            <section className="BecomeArea">
                <div className="section-title">
                    <h6>careers list
                    </h6>
                    <h2>Join the Iline.ai Team
                    </h2>
                    <h5>
                        At Iline.ai, we’re building the future of logistics with electric vehicles and cutting-edge <br /> technology, and we’re looking for passionate individuals to be part of this transformative journey. 🌍⚡
                    </h5>
                    <h5>Ready to Apply?</h5>
                    <h5>Send your application to our head office by emailing us at <a href="javascript:void(0);">Info@Iline.ai.</a> </h5>
                </div>
                {/* <div className="container">
                    <div className="CommonBox">
                        <h5>Inventory Specialist
                        </h5>
                        <p>Rotterdam, NL
                        </p>
                        <p>1st Shift
                        </p>
                        <a href="javascript:void(0);" className="ApplyBtn">Apply Now</a>
                    </div>
                    <div className="CommonBox">
                        <h5>Inventory Specialist
                        </h5>
                        <p>Rotterdam, NL
                        </p>
                        <p>1st Shift
                        </p>
                        <a href="javascript:void(0);" className="ApplyBtn">Apply Now</a>
                    </div>
                    <div className="CommonBox">
                        <h5>Inventory Specialist
                        </h5>
                        <p>Rotterdam, NL
                        </p>
                        <p>1st Shift
                        </p>
                        <a href="javascript:void(0);" className="ApplyBtn">Apply Now</a>
                    </div>
                    <div className="CommonBox">
                        <h5>Inventory Specialist
                        </h5>
                        <p>Rotterdam, NL
                        </p>
                        <p>1st Shift
                        </p>
                        <a href="javascript:void(0);" className="ApplyBtn">Apply Now</a>
                    </div>
                </div> */}
            </section>

            <Footer />
        </>
    )
}

export default Career;